const white950 = '#ffffff';
const white900 = 'rgba(255, 255, 255, 0.9)';
const white800 = 'rgba(255, 255, 255, 0.8)';
const white700 = 'rgba(255, 255, 255, 0.7)';
const white600 = 'rgba(255, 255, 255, 0.6)';
const white500 = 'rgba(255, 255, 255, 0.5)';
const white400 = 'rgba(255, 255, 255, 0.4)';
const white300 = 'rgba(255, 255, 255, 0.3)';
const white200 = 'rgba(255, 255, 255, 0.2)';
const white100 = 'rgba(255, 255, 255, 0.1)';
const white50 = 'rgba(255, 255, 255, 0.05)';

const black950 = '#040506';
const black900 = 'rgba(4, 5, 6, 0.9)';
const black800 = 'rgba(4, 5, 6, 0.8)';
const black700 = 'rgba(4, 5, 6, 0.7)';
const black600 = 'rgba(4, 5, 6, 0.6)';
const black500 = 'rgba(4, 5, 6, 0.5)';
const black400 = 'rgba(4, 5, 6, 0.4)';
const black300 = 'rgba(4, 5, 6, 0.3)';
const black200 = 'rgba(4, 5, 6, 0.2)';
const black100 = 'rgba(4, 5, 6, 0.1)';
const black50 = 'rgba(4, 5, 6, 0.05)';

const brand950 = '#1F003B';
const brand900 = '#2E0057';
const brand800 = '#4C008F';
const brand700 = '#6A00C7';
const brand600 = '#8800FF';
const brand500 = '#9A3BFF';
const brand400 = '#AF73FF';
const brand300 = '#C8A6FF';
const brand200 = '#DECDFF';
const brand100 = '#EEE4FF';
const brand50 = '#F5F0FF';

const grey950 = '#040506';
const grey900 = '#1F2126';
const grey800 = '#2B2E35';
const grey700 = '#43454B';
const grey600 = '#55575D';
const grey500 = '#70737B';
const grey400 = '#A1A3A9';
const grey300 = '#D3D4D8';
const grey200 = '#E6E7E9';
const grey100 = '#F4F4F5';
const grey50 = '#FAFAFA';

const blue950 = '#172554';
const blue900 = '#1E3A8A';
const blue800 = '#1E40AF';
const blue700 = '#1D4ED8';
const blue600 = '#2563EB';
const blue500 = '#3B82F6';
const blue400 = '#60A5FA';
const blue300 = '#93C5FD';
const blue200 = '#BFDBFE';
const blue100 = '#DBEAFE';
const blue50 = '#EFF6FF';

const orange950 = '#4B1004';
const orange900 = '#882814';
const orange800 = '#A5280F';
const orange700 = '#C82D0D';
const orange600 = '#ED3915';
const orange500 = '#FF6647';
const orange400 = '#FF7E64';
const orange300 = '#FFAE9D';
const orange200 = '#FFCFC5';
const orange100 = '#FFE4DF';
const orange50 = '#FFF3F1';

const purple15 = '#500052';
const purple25 = '#770079';
const purple35 = '#8E2390';
const purple50 = '#BB58BC';
const purple60 = '#CC73CE';
const purple80 = '#E7B7E7';
const purple95 = '#FEF5FE';

const green950 = '#03301D';
const green900 = '#0F583A';
const green800 = '#0F6C45';
const green700 = '#0F8655';
const green600 = '#09B06B';
const green500 = '#20DF8F';
const green400 = '#4CE5A6';
const green300 = '#87EEC3';
const green200 = '#BDF5DE';
const green100 = '#DEFAEE';
const green50 = '#F0FDF8';

const yellow950 = '#461901';
const yellow900 = '#7B3306';
const yellow800 = '#973C00';
const yellow700 = '#BB4D00';
const yellow600 = '#E17100';
const yellow500 = '#FE9A00';
const yellow400 = '#FFB900';
const yellow300 = '#FFD230';
const yellow200 = '#FEE685';
const yellow100 = '#FEF3C6';
const yellow50 = '#FFFBEB';

const red950 = '#48070C';
const red900 = '#841821';
const red800 = '#9F1521';
const red700 = '#C11422';
const red600 = '#E51A2B';
const red500 = '#F83B4B';
const red400 = '#FF6A76';
const red300 = '#FFA1A9';
const red200 = '#FFC7CC';
const red100 = '#FFE1E4';
const red50 = '#FFF1F2';

const pink950 = '#4F033C';
const pink900 = '#771860';
const pink800 = '#911775';
const pink700 = '#B21992';
const pink600 = '#D623B3';
const pink500 = '#F243D4';
const pink400 = '#FB5FE1';
const pink300 = '#FEA9F2';
const pink200 = '#FFCFFA';
const pink100 = '#FFE8FD';
const pink50 = '#FFF4FE';

const lightBlue00 = '#7E96B2';
const transparent0 = 'rgba(0,0,0,0)';
const transparent5 = 'rgba(4, 5, 6, 0.05)';
const transparent10 = 'rgba(4, 5, 6, 0.1)';
const black0t32 = `color-mix(in srgb, ${black950}, transparent 68%)`;

export const colorTokens = {
  white950,
  white900,
  white800,
  white700,
  white600,
  white500,
  white400,
  white300,
  white200,
  white100,
  white50,

  black950,
  black900,
  black800,
  black700,
  black600,
  black500,
  black400,
  black300,
  black200,
  black100,
  black50,

  grey950,
  grey900,
  grey800,
  grey700,
  grey600,
  grey500,
  grey400,
  grey300,
  grey200,
  grey100,
  grey50,

  brand950,
  brand900,
  brand800,
  brand700,
  brand600,
  brand500,
  brand400,
  brand300,
  brand200,
  brand100,
  brand50,

  blue950,
  blue900,
  blue800,
  blue700,
  blue600,
  blue500,
  blue400,
  blue300,
  blue200,
  blue100,
  blue50,

  orange950,
  orange900,
  orange800,
  orange700,
  orange600,
  orange500,
  orange400,
  orange300,
  orange200,
  orange100,
  orange50,

  green950,
  green900,
  green800,
  green700,
  green600,
  green500,
  green400,
  green300,
  green200,
  green100,
  green50,

  yellow950,
  yellow900,
  yellow800,
  yellow700,
  yellow600,
  yellow500,
  yellow400,
  yellow300,
  yellow200,
  yellow100,
  yellow50,

  red950,
  red900,
  red800,
  red700,
  red600,
  red500,
  red400,
  red300,
  red200,
  red100,
  red50,

  pink950,
  pink900,
  pink800,
  pink700,
  pink600,
  pink500,
  pink400,
  pink300,
  pink200,
  pink100,
  pink50,

  purple15,
  purple25,
  purple35,
  purple50,
  purple60,
  purple80,
  purple95,

  lightBlue00,
  transparent0,
  transparent5,
  transparent10,
  black0t32,
};
